import { summaryDetails } from '@mage-ui/styled-system/recipes';

export const CourseDetails = ({ data, texts, ...props }) => {
	const classList = summaryDetails().list;
	return (
		<div className={summaryDetails().root} {...props}>
			<h2 className={summaryDetails().title}>{data?.title}</h2>
			<div className={summaryDetails().contentWrapper}>
				<ul>
					{data?.course && (
						<li className={classList}>
							<strong>{data?.course}</strong>
						</li>
					)}
					{data?.course_price && (
						<li className={classList}>
							<strong>{data?.course_price}</strong>
							{texts?.coursePrice}
						</li>
					)}
					{data?.subsidized_price && (
						<li className={classList}>
							<strong>{data?.subsidized_price}</strong>
							{data?.course_discount &&
								`[-${data?.course_discount}] ${texts?.discountApplied}`}
						</li>
					)}
					{data?.material_price && (
						<li className={classList}>
							<strong>{data?.material_price}</strong>
							{texts?.materialPrice}
						</li>
					)}
				</ul>
				{data?.final_price && <hr className={summaryDetails().separator} />}
				{data?.final_price && (
					<p className={classList}>
						<strong>{data?.final_price}</strong>
						{texts?.finalPrice}
					</p>
				)}
			</div>
		</div>
	);
};
